import { render, staticRenderFns } from "./ProductPrices.vue?vue&type=template&id=0a075b62&scoped=true"
import script from "./ProductPrices.vue?vue&type=script&lang=js"
export * from "./ProductPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a075b62",
  null
  
)

export default component.exports